import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ProjectInfoContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading : 1
        }
        

    }
 
    componentDidMount()
    {
         this.setState({loading:0});
        
    }
     
    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
            
            <div class="gallery-single default-padding">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6 thumb">
                                        <div class="gallery  ">
                                            <img src={this.props.project.image} alt={this.props.project.title}/> 
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                            <div class="row">
                                <div class="gallery-details">
                                    <h2>{this.props.project.title}</h2><br/>
                                
            <table width="100%" border="1px;">
            <tbody>
                <tr>
                <td>Project Title </td>
                <td>{this.props.project.project_name}</td>
                </tr>
                <tr>
                <td>Client</td>
                <td>{this.props.project.client}</td>
                </tr>
                <tr>
                <td>MEP Contractor</td>
                <td>{this.props.project.mep_contractor}</td>
                </tr>
                <tr>
                <td>Material</td>
                <td>{this.props.project.material}</td>
                </tr>
                <tr>
                <td>Project Size</td>
                <td>{this.props.project.project_size}</td>
                </tr>
            </tbody>
            </table>

                                    
                                </div>
                            </div>
                        </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
        </div>
       

    );
 
    }
}

export default ProjectInfoContent;